<template>
  <RouterLink
    class="nav-link"
    :to="{ name: menuName.toLowerCase() }"
    :class="[{ wide: isWide }, menuName.toLowerCase()]"
  >
    <component :is="menuName" />
    <div class="menu-name">
      <span>{{ `pages.${menuName.toLowerCase()}` | t }}</span>
    </div>
  </RouterLink>
</template>

<script>
import Dashboard from "@/assets/logos/dashboard.svg";
import Usage from "@/assets/logos/usage.svg";
import Performance from "@/assets/logos/performance.svg";
import Coverage from "@/assets/logos/coverage.svg";
import Datalink from "@/assets/logos/datalink.svg";
import Definitions from "@/assets/logos/icon-help.svg";

export default {
  components: {
    Dashboard,
    Usage,
    Performance,
    Coverage,
    Datalink,
    Definitions,
  },
  props: {
    menuName: {
      type: String,
      required: true,
    },
    isWide: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped lang="scss">
.menu-name {
  font-size: 10px;
}

.nav-link {
  margin: 15px 0;
  text-align: center;
}

.nav-link.wide {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 30px;

  .menu-name {
    margin-left: 10px;
    font-weight: 600;
    font-size: 13px;
  }
}

.menu-list {
  .nav-link {
    color: $color-menu;
  }

  .nav-link:hover,
  .router-link-active {
    color: $primary;
    background-color: initial;

    path:first-child {
      fill: $primary;
    }
  }

  .definitions:hover,
  .definitions.router-link-active {
    color: #fff;

    path:first-child {
      fill: #fff;
    }
  }
}
</style>
